import { ComponentType } from 'react';

import { GetMainAppData_user_permissions } from 'API/MainAppData/__queries__';
import store from 'store';

function reloadPage() {
  // Reload/refresh the page and prevent infinite reload loop.
  // But never reload for a super admin (could lead to problems since they handle several companies)
  const userRole = store.getState().userRole;
  //if (userRole === 'SUPER_ADMIN') return false;
  if (!sessionStorage.getItem('reloadedBefore')) {
    sessionStorage['reloadedBefore'] = true;
    window.location.reload();
    return true;
  } else {
    sessionStorage.removeItem('reloadedBefore');
    return false;
  }
}

function retry(fn, retriesLeft = 4) {
  //Tries and retries to do a dynamic import.
  //Handles chunk load errors by reloading whole page.
  return new Promise<{ default: ComponentType<any> }>((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 0) {
            //Here all retries have failed and we might have a chunk load error problem
            //So lets reload the page to provoke a browser cache update
            const reloadSuccess = reloadPage();
            //If that failed, bail out with error
            if (!reloadSuccess) return reject(error);
            return;
          }
          retry(fn, retriesLeft - 1).then(resolve, reject);
        }, 500);
      });
  });
}

export { reloadPage, retry };

export const filterVenuesByPermissions = (
  venues: any[],
  userPermissions: GetMainAppData_user_permissions | null,
) => {
  // Filter out venues that user don't have permission to
  return userPermissions?.venueIds.length === 0
    ? venues
    : venues.filter((venue) => userPermissions?.venueIds.includes(venue.id));
};
